import {
  BaSeDatePicker,
  BaSeInput,
  BaSeParagraph,
  BaSeRadio,
  BaSeTheme,
} from '@base/react';
import React from 'react';
import {
  AlignHeaderContainer,
  HeaderContainer,
} from './modal-generate-certificate-style';

function FormHeaderGenerateCertificate({
  setCargaHoraria,
  setInitialDate,
  initialDate,
  setFinalDate,
  finalDate,
  cargaHoraria,
  radioTypeSeminar,
  setRadioTypeSeminar,
  moduleSelected
}) {
  const handleChangeWorkload = React.useCallback(
    (e) => {
      if (isNaN(+e) || e.includes('.') || e.includes(' ')) {
        return;
      }
      setCargaHoraria(e);
    },
    [setCargaHoraria],
  );

  return (
    <HeaderContainer>
      <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
        Lista de candidato(s) selecionado(s) para geração de certificado(s)
      </BaSeParagraph>
      <AlignHeaderContainer>
        <>
          <BaSeDatePicker
            startDate={initialDate}
            label="Data do Seminário"
            onStartDateChange={setInitialDate}
            onBlur={(e) => {
              setInitialDate((date) => date);
            }}
            onSelect={(date) => {
              setInitialDate(date);
            }}
            placeholder="Data de início"
          />

          <BaSeDatePicker
            startDate={finalDate}
            isDisabled={!initialDate}
            minDate={
              new Date(
                new Date(initialDate).setDate(
                  new Date(initialDate).getDate() + 1,
                ),
              )
            }
            onStartDateChange={setFinalDate}
            onBlur={(e) => {
              setFinalDate((date) => date);
            }}
            onSelect={(date) => {
              setFinalDate(date);
            }}
            placeholder="Data de término"
            label="  "
          />
        </>



        <div>
          <BaSeInput
            suffix=" horas"
            label="Carga horária"
            placeholder={`${cargaHoraria} horas`}
            value={cargaHoraria}
            onChange={handleChangeWorkload}
            inputMode="decimal"
            maxLength={9}
          />
        </div>

        {
          moduleSelected?.id === 1 && (
            <div>
              <BaSeParagraph color="#617385">Tipo de seminário</BaSeParagraph>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <BaSeRadio
                  checked={radioTypeSeminar === 5}
                  color="default"
                  id={5}
                  label="5 Dias"
                  name="FIVE_DAYS"
                  onChange={() => setRadioTypeSeminar(5)}
                  shape="circle"
                  size="medium"
                />

                <BaSeRadio
                  checked={radioTypeSeminar === 6}
                  color="default"
                  id={6}
                  label="6 Dias"
                  name="SIX_DAYS"
                  onChange={() => setRadioTypeSeminar(6)}
                  shape="circle"
                  size="medium"
                />
              </div>
            </div>
          )
        }


      </AlignHeaderContainer>
    </HeaderContainer>
  );
}

export default FormHeaderGenerateCertificate;
